import { ButtonLink, Container, RiAddLine } from 'component-library';
import { useTranslation } from 'react-i18next';

import { WidgetType } from '@/api/rest/resources/types/widget';
import { WidgetSlotRenderer } from '@/components/widgets/WidgetSlotRenderer';
import { useIsStaffUser } from '@/hooks/useIsStaffUser';
import { useActiveWidgetSlotConfiguration } from '@/hooks/useWidgetConfigurationByOrganizationId';
import { SignedInPageLayout } from '@/layout/signed-in-page';
import { paths } from '@/routing';
import { isNullish } from '@/utils/booleans';

import { useMenuItems } from '../hooks/useMenuItems';
import { WorkstreamPage } from '../workstreams/pages/Workstream.page';
import { UserGreetings } from './components/UserGreetings';
import { Workstreams } from './components/Workstreams';
import { useWorkstreamId } from './hooks/useWorkstreamId';

export const HomePage = () => {
  const workstreamId = useWorkstreamId();

  if (isNullish(workstreamId)) {
    return <WorkstreamsPage />;
  }

  return <WorkstreamPage />;
};

const WorkstreamsPage = () => {
  const { t } = useTranslation();
  const menuItems = useMenuItems();
  const isStaff = useIsStaffUser();

  const defaultWidgetConfiguration = useDefaultWidgetConfiguration();
  const customWidgetSlotsConfiguration = useActiveWidgetSlotConfiguration('default_template_home', WidgetType.t_page);
  const widgetSlotsConfiguration = customWidgetSlotsConfiguration ?? defaultWidgetConfiguration;

  return (
    <SignedInPageLayout
      items={menuItems}
      navBarProps={{
        title: t('navbar.home'),
        showFilters: false,
        children: isStaff && (
          <ButtonLink to={paths.staff.workstreamsAdd} variant='contained' leftAdornment={<RiAddLine />}>
            {t('global.workstream.actions.add')}
          </ButtonLink>
        ),
      }}
    >
      <Container gutterWidth={{ sm: 4 }} className='gap-10 my-8'>
        <UserGreetings />
        <Workstreams />
        <WidgetSlotRenderer nestedWidget={widgetSlotsConfiguration} />
      </Container>
    </SignedInPageLayout>
  );
};

const useDefaultWidgetConfiguration = () => {
  return {
    name: 'default_template_home',
    type: WidgetType.t_page,
    widgets: [],
  };
};
